import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";

import Modal from "../../../components/Modal";
import { post } from "../../../actions/general";
import resetUser from "../../../store/user/actions/resetUser";
import Form, { Submit, Title, InputPassword, Cancel } from "../../../components/Form";
import messages from "../messages";
import { ICloseProp } from "../interfaces";
import { getAppFromHistory, getAppPrefix } from "../../../../common/app";

const DeleteAccountModal = ({ close }: ICloseProp) => {
    const { formatMessage } = useIntl();
    const history = useHistory();
    const dispatch = useDispatch();
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [validation, setValidation] = useState<string | undefined>(undefined);
    const submit = () => {
        if (!password) {
            setValidation("required");
            return
        };
        let areYouSure = window.confirm(formatMessage(messages.deleteAccountConfirm));
        if (areYouSure) {
            setLoading(true);
            dispatch(post("delete-account", { password }, res => {
                const { data } = res;
                if (data.success) {
                    history.push(getAppPrefix(getAppFromHistory(history)));
                    setTimeout(() => {
                        dispatch(resetUser());
                    }, 500);
                } else {
                    setValidation("wrongPassword")
                    setLoading(false);
                }
            }));
        }
    };
    return (
        <Modal close={close}>
            <Form disabled={loading}>
                <Title>
                    <FormattedMessage {...messages.deleteAccountTitle} />
                </Title>
                <InputPassword
                    required
                    validation={validation}
                    label={formatMessage(messages.password)}
                    value={password}
                    onChange={e => {
                        setPassword(e.currentTarget.value);
                        setValidation(undefined);
                    }}
                />
                <Submit onClick={submit} loading={loading}>
                    <FormattedMessage {...messages.deleteAccountButton} />
                </Submit>
                <Cancel onClick={() => close()}>
                    <FormattedMessage {...messages.cancel} />
                </Cancel>
            </Form>
        </Modal>
    );
};

export default DeleteAccountModal;
